// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__kBJ2W","head":"Table_head__33-kc","col":"Table_col__2EIi4"};